/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditTag from './EditTag/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import SearchResult from './SearchResult/index'
import SearchTerm from './SearchTerm/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Tags/Content",
  innerRef,
  left,
  top
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--l-1-Z1Yf8zk': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1Yf8zk': typeof top === 'number' ? `${top}px` : top,'--bc-3-Z1Yf8zk': dtColorsWhite,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-8-Z1Yf8zk': isBefore ? 0 : 1,'--ty-9-Z1Yf8zk': isBefore ? "-8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingTop={dtSpaceXs}
 paddingRight={dtSpaceLs}
 paddingBottom={dtSpaceXs}
 paddingLeft={dtSpaceLs}
 text="Tags"
 weight="medium"
 fontSize={dtTypographyFontsizeMm}
 color={dtColorsNeutral500}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<SearchTerm
  viewPath={`${viewPath}/SearchTerm`}
/>
</div>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<EditTag
  viewPath={`${viewPath}/EditTag`}
/>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--pt-10-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-12-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical3}`}
>
<SearchResult
  viewPath={`${viewPath}/SearchResult`}
/>
</div>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}